import { render, staticRenderFns } from "./ProductsMenu.vue?vue&type=template&id=a0fb777a&scoped=true&"
import script from "./ProductsMenu.vue?vue&type=script&lang=ts&"
export * from "./ProductsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsMenu.vue?vue&type=style&index=0&id=a0fb777a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fb777a",
  null
  
)

export default component.exports